import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { general_settings_labels } from "../../../Constants/Labels";
import { callAPI, useStore, useUser } from "../../../Utils/utils";
import { errorMessages } from "../../../Constants/Errors";
import { useParams } from "react-router-dom";
import { general_settings_message, select_store_message, alert_message_type } from "../../../Constants/Messages"
import Layout from "../../../Components/Global/Layout";
import BreadCrumb from '../../../Components/Global/BreadCrumb/BreadCrumb';
import Message from "../../../Components/Message/Message";
import Alert from "../../../Components/Alert/Alert";
import Loader from "../../../Components/Global/Loader/Loader";
import ErrorMessage from "../../../Components/Global/ErrorMessage";
import RichTextEditor from "../../../Components/Global/RichTextEditor/RichTextEditor";
import "./GeneralSettingsPage.css";

const GeneralSettingsPage = () => {

    const navigate = useNavigate()
    const [alert, setAlert] = useState()
    const { user, setUser } = useUser();
    const [errors, setErrors] = useState();
    const { store, setStore } = useStore();
    const [loading, setLoading] = useState(false)
    const [storeName, setStoreName] = useState([]);
    const [formValues, setformValues] = useState();
    const [refreshCount, setRefreshCount] = useState(0)
    const [showErrorMessage, setShowErrorMessage] = useState()
    const [uploading, setUploading] = useState(false);
    var { id } = useParams();
    var storeId = store?.id

    useEffect(() => {
        if (store?.name != "Global Admin") {
            if (storeName?.length == 0 || storeName == undefined) {
                setStoreName(() => [store?.name])
            }
            else {
                setStoreName((existingStoreId) => [...existingStoreId, store?.name])
            }
        }
    }, [store?.id])

    useEffect(() => {
        const store_name = storeName?.filter((value, index, self) => self.indexOf(value) === index);
        if (store_name[1] != undefined) {
            if (store_name[0] != store_name[1]) {
                navigate("/admin")
                setStoreName([])
            }
        }
    }, [storeName])

    // store onchanged values in state
    const onChangeField = (event) => {
        setformValues({ ...formValues, [event.target.name]: event.target.value })
        setShowErrorMessage(false)
        setErrors([])
    }

    // handle rich text editor changes
    const onRichTextChange = (name, value) => {
        setformValues({ ...formValues, [name]: value })
        setShowErrorMessage(false)
        setErrors([])
    }

    // handle image upload
    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file size (1MB limit)
        const fileSize = file.size / (1024 * 1024);
        if (fileSize > 1) {
            setAlert({ text: "File size exceeds 1MB limit", type: "error" });
            return;
        }

        // Validate file type
        if (!file.type.match('image.*')) {
            setAlert({ text: "Please select an image file", type: "error" });
            return;
        }

        setUploading(true);

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('store_id', storeId > 0 ? storeId : id);

            const response = await callAPI('/admin/images/upload', {
                method: 'POST',
                headers: {
                    'token': user?.auth_token
                },
                body: formData
            }, navigate, setUploading);

            console.log('Upload response:', response); // Debug log

            if (response.success) {
                
                // Try different possible response structures
                const imagePath = response.path || response.data?.path || response.record?.path || response.image_path;
                console.log('Image path found:', imagePath); // Debug log
                
                if (imagePath) {
                    console.log('Updating formValues with imagePath:', imagePath);
                    setformValues({ ...formValues, footerLogo: imagePath });
                    console.log('FormValues updated');
                    setAlert({ text: "Image uploaded successfully", type: "success" });
                } else {
                    setAlert({ text: "Upload successful but no image path received", type: "error" });
                }
            } else {
                setAlert({ text: "Upload failed. Please try again.", type: "error" });
            }
        } catch (error) {
            setAlert({ text: "Upload failed. Please try again.", type: "error" });
        } finally {
            setUploading(false);
            // Reset file input
            event.target.value = '';
        }
    }

    // remove footer logo
    const removeFooterLogo = () => {
        setformValues({ ...formValues, footerLogo: "" });
    }

    // Debug: Monitor formValues changes
    useEffect(() => {
        console.log('formValues changed:', formValues);
    }, [formValues]);

    // Load existing store data
    useEffect(() => {
        if (storeId && (!refreshCount || refreshCount === 0)) {
            callAPI(`/admin/stores/${storeId}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                }
            }, navigate, setLoading)
            .then(data => {
                console.log('data', data);
                console.log('data.success:', data.success);
                console.log('data.record:', data.record);
                console.log('data.record.settings:', data.record?.settings);
                
                if (data.success && data.record && data.record.settings) {
                    console.log('Setting form values from settings');
                    // Set form values with existing store data from settings
                    setformValues({
                        email_logo: data.record.settings.email_logo || "",
                        heading: data.record.settings.email_footer_heading || "",
                        copy: data.record.settings.email_footer_copy || "",
                        phone: data.record.settings.phone || "",
                        website: data.record.settings.website || "",
                        website_lable: data.record.settings.website_label || "",
                        order_footer_copy: data.record.settings.email_order_footer_copy || "",
                        ecard_font_color: data.record.settings.ecard_font_color || ""
                    });
                    console.log('Loaded existing store data:', data.record.settings);
                } else {
                    console.log('No settings data found, using empty values');
                    // Initialize with empty values if no settings exist
                    setformValues({
                        email_logo: "",
                        email_footer_heading: "",
                        email_footer_copy: "",
                        phone: "",
                        website: "",
                        website_lable: "",
                        email_order_footer_copy: "",
                        ecard_font_color: ""
                    });
                }
            })
            .catch(error => {
                console.error('Error loading store data:', error);
            });
        }
    }, [storeId, id, refreshCount]);

    const saveGeneralSettings = () => {
        const pay_load = {
            "store_id": storeId > 0 ? storeId : id,
            "email_logo": formValues?.['footerLogo'] ? formValues['footerLogo'] : "",
            "email_footer_heading": formValues?.['heading'] ? formValues['heading'] : "",
            "email_footer_copy": formValues?.['copy'] ? formValues['copy'] : "",
            "phone": formValues?.['phone'] ? formValues['phone'] : "",
            "website": formValues?.['website'] ? formValues['website'] : "",
            "website_lable": formValues?.['website_lable'] ? formValues['website_lable'] : "",
            "email_order_footer_copy": formValues?.['order_footer_copy'] ? formValues['order_footer_copy'] : "",
            "ecard_font_color": formValues?.['ecard_font_color'] ? formValues['ecard_font_color'] : ""
        }
        
        callAPI("/admin/stores/update",
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': user?.auth_token
                },
                body: JSON.stringify(pay_load)
            }, navigate, setLoading)
            .then(data => {
                if (data.success == true) {
                    setAlert({ text: general_settings_message?.saved_message, type: alert_message_type?.success })
                    setRefreshCount(refreshCount + 1)
                } else {
                    setErrors(data?.errors)
                    setShowErrorMessage(true)
                }
            }
            )
    }

    let select_store = store?.id == null || store?.id == undefined || store?.id == 0 || store?.name == "Global Admin" ? true : false
console.log("formvalues", formValues);

    return (
        <Layout>
            {alert?.text == general_settings_message?.saved_message ?
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
                : ''}
            {loading &&
                <Loader className={"page_loader"} />
            }
            {!loading &&
                <>
                    <div className="breadcrumb-wrapper breadcrumb-contacts">
                        <BreadCrumb />
                    </div>
                    <>
                        {select_store && !id ?
                            <div className="card card-default">
                                <div className={`card-body select_store`}>
                                    <p className="text-center">{select_store_message?.select_store}</p>
                                </div>
                            </div>
                            :
                            <>
                                <div className="card card-default">
                                    <div className="card-body over_all_general_settings_wrapper">
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.footer_logo}</label>
                                            <div className="footer_logo_upload_section">
                                                <input
                                                    type="file"
                                                    id="footerLogoUpload"
                                                    accept="image/*"
                                                    onChange={handleImageUpload}
                                                    style={{ display: 'none' }}
                                                />
                                                {/* Debug: Show current formValues.footerLogo */}
                                                {console.log('Current formValues.footerLogo:', formValues?.footerLogo)}
                                                {formValues?.["email_logo"] ? (
                                                    <div className="selected_logo_preview">
                                                        {/* Debug: Show what's being rendered */}
                                                        {console.log('Rendering image with src:', formValues?.["footerLogo"])}
                                                        <img src={formValues?.["email_logo"]} alt="Footer Logo" className="footer_logo_preview" />
                                                        <div className="logo_actions">
                                                            <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => document.getElementById('footerLogoUpload').click()}>
                                                                <i className="mdi mdi-window-close"></i>
                                                            </button>
                                                        </div>
                                                        <div className="delete_overlay" onClick={removeFooterLogo}>
                                                            <div className="trash_icon_show">
                                                                <i className="mdi mdi-window-close"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="upload_logo_placeholder">
                                                        <div className="upload_icon" onClick={() => document.getElementById('footerLogoUpload').click()}>
                                                            {uploading ? (
                                                                <div className="upload_loading">
                                                                    <div className="spinner-border spinner-border-sm" role="status">
                                                                        <span className="sr-only">Uploading...</span>
                                                                    </div>
                                                                    <p>Uploading...</p>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <svg width="50px" height="50px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g id="style=fill">
                                                                            <g id="add-circle">
                                                                                <path id="Subtract" fillRule="evenodd" clipRule="evenodd"
                                                                                    d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 7.00738C12.4142 7.00739 12.75 7.34317 12.75 7.75739L12.75 11.25L16.25 11.25C16.6642 11.25 17 11.5858 17 12C17 12.4142 16.6642 12.75 16.25 12.75L12.75 12.75L12.75 16.2426C12.75 16.6568 12.4142 16.9926 12 16.9926C11.5857 16.9926 11.25 16.6568 11.25 16.2426L11.25 12.75L7.76476 12.75C7.35055 12.75 7.01476 12.4142 7.01476 12C7.01477 11.5857 7.35055 11.25 7.76477 11.25L11.25 11.25L11.25 7.75738C11.25 7.34317 11.5858 7.00738 12 7.00738Z"
                                                                                    fill="#d5d5d5" />
                                                                            </g>
                                                                        </g>
                                                                    </svg>
                                                                    <p>Add Logo</p>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'footerLogo', errors })] || ErrorMessage({ fieldName: 'footerLogo', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.footer_heading}</label>
                                            <input type="text" className="form-control" name="heading" value={formValues?.["heading"] || ""} onChange={onChangeField} />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'heading', errors })] || ErrorMessage({ fieldName: 'heading', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.footer_copy}</label>
                                            <RichTextEditor 
                                                name="copy" 
                                                value={formValues?.["copy"] || ""} 
                                                onChange={onRichTextChange}
                                            />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'copy', errors })] || ErrorMessage({ fieldName: 'copy', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.footer_phone}</label>
                                            <input type="tel" className="form-control" name="phone" value={formValues?.["phone"] || ""} onChange={onChangeField} />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'phone', errors })] || ErrorMessage({ fieldName: 'phone', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.footer_website}</label>
                                            <input type="url" className="form-control" name="website" value={formValues?.["website"] || ""} onChange={onChangeField} placeholder="https://example.com" />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'website', errors })] || ErrorMessage({ fieldName: 'website', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.footer_website_label}</label>
                                            <input type="text" className="form-control" name="website_lable" value={formValues?.["website_lable"] || ""} onChange={onChangeField} />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'website_lable', errors })] || ErrorMessage({ fieldName: 'website_lable', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.order_footer_copy}</label>
                                            <RichTextEditor 
                                                name="order_footer_copy" 
                                                value={formValues?.["order_footer_copy"] || ""} 
                                                onChange={onRichTextChange}
                                            />
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'order_footer_copy', errors })] || ErrorMessage({ fieldName: 'order_footer_copy', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_wrapper">
                                            <label className="form-label">{general_settings_labels?.ecard_font_color}</label>
                                            <div className="d-flex align-items-center">
                                                <input 
                                                    type="color" 
                                                    className="form-control" 
                                                    style={{width: '60px', height: '38px'}}
                                                    name="ecard_font_color" 
                                                    value={formValues?.["ecard_font_color"] || "#000000"} 
                                                    onChange={onChangeField} 
                                                />
                                                <input 
                                                    type="text" 
                                                    className="form-control ml-3" 
                                                    placeholder="#000000"
                                                    name="ecard_font_color" 
                                                    value={formValues?.["ecard_font_color"] || "#000000"} 
                                                    onChange={onChangeField} 
                                                    style={{textTransform: 'uppercase'}}
                                                />
                                            </div>
                                            <div className="errorMessage">
                                                <Message text={errorMessages[ErrorMessage({ fieldName: 'ecard_font_color', errors })] || ErrorMessage({ fieldName: 'ecard_font_color', errors })} type={"errorMsg"} showMessage={showErrorMessage} />
                                            </div>
                                        </div>
                                        <div className="general_settings_btn_wrapper">
                                            <button className="btn btn-primary" onClick={saveGeneralSettings}>{general_settings_labels?.save_button}</button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>
                </>
            }
        </Layout>
    )
}
export default GeneralSettingsPage;
